import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  fieldObjectTasks,
  headersTasks,
  valoresExibidosOffCanvasTasks,
} from './auxiliarTasks';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useInterfaceSisaf } from '../../../../services/enum/useInterfaceSisaf';
import { useModuloDaf } from '../../../../services/enum/useModuloDaf';
import { useResponsavelTask } from '../../../../services/enum/useResponsavelTask';
import { useTipoTask } from '../../../../services/enum/useTipoTask';
import { getAllTasksSisAf } from '../../../../services/gestaoSisAF/tasksSisAfService';
import { ENTITY } from '../../../../utils/entityNames';
import {
  calcularDiferencaEmDias,
  ExportToExcel,
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../utils/functions';
import { getSubAbas } from '../subabas';

const MaisOpcoesTasks: React.FC = () => {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_Tasks;
  const navigate = useNavigate();
  const interfaceSisaf = useInterfaceSisaf();
  const moduloDaf = useModuloDaf();
  const tipoTask = useTipoTask();
  const responsavelTask = useResponsavelTask();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    interfaceSisAf: 0,
    moduloSisAf: 0,
    tipoTask: 0,
    responsavel: 0,
    dataEntrada: '',
    dataFinalizacao: '',
    funcionalidade: '',
    descricao: '',
    complexidade: '',
    reaproveitamentoCodigo: '',
    statusDesenvolvimento: '',
    pontosFuncionalidade: 0,
    pontosDesenvolvidos: 0,
    observacoes: '',
    level: '',
  });
  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllTasksSisAf();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const tableData = data
    .filter((item) => {
      const pontosFuncionalidade =
        item.complexidade * item.reaproveitamentoCodigo;
      const statusDev = Number(item.statusDesenvolvimento) * 10;

      // Lógica de filtragem para interfaceSisAf e moduloSisAf
      const interfaceSisAfFilter =
        formFiltros.interfaceSisAf === 0 ||
        String(item.interfaceSisAf) === String(formFiltros.interfaceSisAf);
      const moduloSisAfFilter =
        formFiltros.moduloSisAf === 0 ||
        String(item.moduloSisAf) === String(formFiltros.moduloSisAf);
      const responsavelFilter =
        formFiltros.responsavel === 0 ||
        String(item.responsavel) === String(formFiltros.responsavel);
      const funcionalidadeFilter =
        formFiltros.funcionalidade === '' ||
        item.funcionalidade
          .toLowerCase()
          .includes(formFiltros.funcionalidade.toLowerCase());

      // Lógica de filtragem para level
      let levelFilter = true;
      if (formFiltros.level.startsWith('<')) {
        const value = parseInt(formFiltros.level.substring(1), 10);
        if (!isNaN(value)) {
          levelFilter = pontosFuncionalidade < value;
        }
      } else if (formFiltros.level.startsWith('>')) {
        const value = parseInt(formFiltros.level.substring(1), 10);
        if (!isNaN(value)) {
          levelFilter = pontosFuncionalidade > value;
        }
      } else if (/^[0-9]+$/.test(formFiltros.level)) {
        const value = parseInt(formFiltros.level, 10);
        levelFilter = pontosFuncionalidade === value;
      }

      // Lógica de filtragem para statusDesenvolvimento
      let statusFilter = true;
      if (formFiltros.statusDesenvolvimento.startsWith('<')) {
        const value = parseInt(
          formFiltros.statusDesenvolvimento.substring(1),
          10,
        );
        if (!isNaN(value)) {
          statusFilter = statusDev < value;
        }
      } else if (formFiltros.statusDesenvolvimento.startsWith('>')) {
        const value = parseInt(
          formFiltros.statusDesenvolvimento.substring(1),
          10,
        );
        if (!isNaN(value)) {
          statusFilter = statusDev > value;
        }
      } else if (/^[0-9]+$/.test(formFiltros.statusDesenvolvimento)) {
        const value = parseInt(formFiltros.statusDesenvolvimento, 10);
        statusFilter = statusDev === value;
      }

      // Retornar somente se todos os filtros forem verdadeiros
      return (
        interfaceSisAfFilter &&
        moduloSisAfFilter &&
        funcionalidadeFilter &&
        responsavelFilter &&
        levelFilter &&
        statusFilter
      );
    })
    .map((item) => {
      const pontos = item.complexidade * item.reaproveitamentoCodigo;
      const statusDev = Number(item.statusDesenvolvimento);
      const statusPercentage = (statusDev / 10) * 100; // Convertendo de 0 a 10 para 0% a 100%

      // Determina o nível de vermelho, de vermelho claro para vermelho escuro
      const redIntensity = Math.min(255, Math.floor((pontos / 100) * 255));
      let backgroundColor = '';
      if (pontos < 51) {
        backgroundColor = `rgb(250, ${220 - redIntensity}, ${220 - redIntensity})`;
      } else {
        backgroundColor = `rgb(200, ${220 - redIntensity}, ${220 - redIntensity})`;
      }
      const textColor = pontos > 29 ? '#ffffff' : '#000000';

      // Lógica para determinar a cor do status
      let r, g, b;

      if (statusDev === 0) {
        r = 180;
        g = 0;
        b = 0;
      } else if (statusDev <= 5) {
        const vermelho = [230, 100, 100];
        const amarelo = [255, 255, 0];
        const interpolacao = statusDev / 5; // De 0 a 5 (metade da escala)

        r = Math.round(vermelho[0] + (amarelo[0] - vermelho[0]) * interpolacao);
        g = Math.round(vermelho[1] + (amarelo[1] - vermelho[1]) * interpolacao);
        b = Math.round(vermelho[2] + (amarelo[2] - vermelho[2]) * interpolacao);
      } else {
        const amarelo = [255, 255, 0];
        const verde = [0, 210, 0];
        const interpolacao = (statusDev - 5) / 5; // De 5 a 10 (segunda metade da escala)

        r = Math.round(amarelo[0] + (verde[0] - amarelo[0]) * interpolacao);
        g = Math.round(amarelo[1] + (verde[1] - amarelo[1]) * interpolacao);
        b = Math.round(amarelo[2] + (verde[2] - amarelo[2]) * interpolacao);
      }

      const statusBackgroundColor = `rgb(${r}, ${g}, ${b})`;
      const statusTextColor =
        statusDev === 0 || statusDev <= 2 || statusDev === 10
          ? '#ffffff'
          : '#000000';

      return {
        id: item.id,
        interfaceSisAf: interfaceSisaf[item.interfaceSisAf].label,
        moduloSisAf: moduloDaf[item.moduloSisAf].label,
        funcionalidade: item.funcionalidade,
        responsavel: responsavelTask[item.responsavel].label,
        complexidade: (
          <div style={{ textAlign: 'right' }}>
            <span
              style={{
                backgroundColor: backgroundColor,
                borderRadius: '10px',
                padding: '10px',
                color: textColor,
                marginLeft: '0px',
              }}
            >
              {pontos}
            </span>
          </div>
        ),
        statusDesenvolvimento: (
          <div style={{ textAlign: 'right' }}>
            <span
              style={{
                backgroundColor: statusBackgroundColor,
                borderRadius: '10px',
                padding: '10px',
                color: statusTextColor,
                display: 'inline-block',
                minWidth: '50px',
              }}
            >
              {statusPercentage.toFixed(1)}%
            </span>
          </div>
        ),
      };
    });

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => {
    const pontos = item.complexidade * item.reaproveitamentoCodigo;

    // Determina o nível de vermelho, de vermelho claro para vermelho escuro
    const redIntensity = Math.min(255, Math.floor((pontos / 100) * 255));
    let backgroundColor = '';
    if (pontos < 51) {
      backgroundColor = `rgb(250, ${220 - redIntensity}, ${220 - redIntensity})`;
    } else {
      backgroundColor = `rgb(200, ${220 - redIntensity}, ${220 - redIntensity})`;
    }
    const textColor = pontos > 29 ? '#ffffff' : '#000000';

    // Lógica para determinar a cor do status
    const statusDev = Number(item.statusDesenvolvimento);
    let r, g, b;

    if (statusDev == 0) {
      r = 180;
      g = 0;
      b = 0;
    } else if (statusDev <= 6) {
      // Interpolar entre vermelho e amarelo (status de 1 a 5)
      const vermelho = [230, 100, 100];
      const amarelo = [255, 255, 0];
      const interpolacao = (statusDev - 1) / 5;

      r = Math.round(vermelho[0] + (amarelo[0] - vermelho[0]) * interpolacao);
      g = Math.round(vermelho[1] + (amarelo[1] - vermelho[1]) * interpolacao);
      b = Math.round(vermelho[2] + (amarelo[2] - vermelho[2]) * interpolacao);
    } else {
      // Interpolar entre amarelo e verde (status de 6 a 10)
      const amarelo = [255, 255, 0];
      const verde = [0, 210, 0];
      const interpolacao = (statusDev - 6) / 4;

      r = Math.round(amarelo[0] + (verde[0] - amarelo[0]) * interpolacao);
      g = Math.round(amarelo[1] + (verde[1] - amarelo[1]) * interpolacao);
      b = Math.round(amarelo[2] + (verde[2] - amarelo[2]) * interpolacao);
    }

    const statusBackgroundColor = `rgb(${r}, ${g}, ${b})`;
    const statusTextColor =
      statusDev === 0 || statusDev <= 2 || statusDev >= 10
        ? '#ffffff'
        : '#000000';

    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      interfaceSisAf: interfaceSisaf[item.interfaceSisAf].label,
      moduloSisAf: moduloDaf[item.moduloSisAf].label,

      funcionalidade: (
        <b style={{ fontSize: '1.25rem' }}>
          {item.funcionalidade.toUpperCase()}
        </b>
      ),
      descricao: item.descricao,
      complexidade: item.complexidade,
      reaproveitamentoCodigo: item.reaproveitamentoCodigo,
      pontosFuncionalidade: (
        <>
          <div
            style={{
              textAlign: 'left',
              justifySelf: 'flex-start',
              margin: '-5px',
              padding: '5px',
            }}
          >
            <span
              style={{
                backgroundColor: backgroundColor,
                borderRadius: '10px',
                padding: '10px',
                color: textColor,
              }}
            >
              {pontos}
            </span>
          </div>
        </>
      ),
      statusDesenvolvimento: (
        <div
          style={{
            textAlign: 'left',
            justifySelf: 'flex-start',
            margin: '-5px',
            padding: '5px',
          }}
        >
          <span
            style={{
              backgroundColor: statusBackgroundColor,
              borderRadius: '10px',
              padding: '10px',
              color: statusTextColor,
              display: 'inline-block',
              minWidth: '50px',
            }}
          >
            {(item.statusDesenvolvimento * 10).toFixed(1)}%
          </span>
        </div>
      ),
      separadorFuncionalidade: '',
      tipoTask: tipoTask[item.tipoTask].label,
      responsavel: responsavelTask[item.responsavel].label,
      dataEntrada: formatDateSimp(item.dataEntrada),
      dataFinalizacao: formatDateSimp(item.dataFinalizacao),
      diasDev: calcularDiferencaEmDias(
        formatDateSimp(item.dataEntrada),
        formatDateSimp(item.dataFinalizacao),
      ),
      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'level' || name === 'statusDesenvolvimento') {
      // Permitir somente números, '<', '>', ou uma combinação destes com números
      if (
        /^[0-9]*$/.test(value) ||
        value === '<' ||
        value === '>' ||
        /^[<>][0-9]+$/.test(value)
      ) {
        setFormFiltros((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === 'interfaceSisAf' || name === 'moduloSisAf') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        [name]: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      interfaceSisAf: 0,
      moduloSisAf: 0,
      tipoTask: 0,
      responsavel: 0,
      dataEntrada: '',
      dataFinalizacao: '',
      funcionalidade: '',
      descricao: '',
      complexidade: '',
      reaproveitamentoCodigo: '',
      statusDesenvolvimento: '',
      pontosFuncionalidade: 0,
      pontosDesenvolvidos: 0,
      observacoes: '',
      level: '',
    });
  };

  interface ExportData {
    id: number;
    dataRegistro: string;
    usuarioRegistro: {
      nomeCompleto: string;
    };
    dataUltimaAtualizacao: string;
    usuarioAtualizacao: {
      nomeCompleto: string;
    };
    dataUltimaVisualizacao: string;
    usuarioUltimaVisualizacao: {
      nomeCompleto: string;
    };
    nEdicoes: number;
    nVisualizacoes: number;
    nVisualizadores: number;

    //Específicos
    interfaceSisAf: number;
    moduloSisAf: number;
    tipoTask: number;
    responsavel: number;
    dataEntrada: string;
    dataFinalizacao: string;
    funcionalidade: string;
    descricao: string;
    complexidade: number;
    reaproveitamentoCodigo: number;
    level: number;
    statusDesenvolvimento: number;

    //Observações
    observacoes: string;
  }

  const prepareDataForExport = (data: ExportData[]) => {
    return data.map((item) => {
      return {
        id: item.id,

        //Logs
        dataRegistro: item.dataRegistro,
        usuarioRegistro: item.usuarioRegistro.nomeCompleto,
        dataUltimaAtualizacao: item.dataUltimaAtualizacao,
        usuarioAtualizacao: item.usuarioAtualizacao.nomeCompleto,
        dataUltimaVisualizacao: item.dataUltimaVisualizacao,
        usuarioUltimaVisualizacao: item.usuarioUltimaVisualizacao.nomeCompleto,
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        nVisualizadores: item.nVisualizadores,

        //Específicos
        interfaceSisAf: interfaceSisaf[item.interfaceSisAf]?.label || '',
        moduloSisAf: moduloDaf[item.moduloSisAf]?.label || '',
        funcionalidade: item.funcionalidade,
        descricao: item.descricao,
        complexidade: item.complexidade,
        reaproveitamentoCodigo: item.reaproveitamentoCodigo,
        level: item.complexidade * item.reaproveitamentoCodigo,
        statusDesenvolvimento: item.statusDesenvolvimento * 10,
        dataEntrada: item.dataEntrada,
        dataFinalizacao: item.dataFinalizacao,
        responsavel: responsavelTask[item.responsavel].label,

        //Observações
        observacoes: item.observacoes,
      };
    });
  };

  // Criar a versão filtrada dos dados para exportação
  const filteredDataForExport = data.filter((item) => {
    const pontosFuncionalidade =
      item.complexidade * item.reaproveitamentoCodigo;
    const statusDev = Number(item.statusDesenvolvimento) * 10;

    // Lógica de filtragem para interfaceSisAf e moduloSisAf
    const interfaceSisAfFilter =
      formFiltros.interfaceSisAf === 0 ||
      String(item.interfaceSisAf) === String(formFiltros.interfaceSisAf);
    const moduloSisAfFilter =
      formFiltros.moduloSisAf === 0 ||
      String(item.moduloSisAf) === String(formFiltros.moduloSisAf);
    const responsavelFilter =
      formFiltros.responsavel === 0 ||
      String(item.responsavel) === String(formFiltros.responsavel);
    const funcionalidadeFilter =
      formFiltros.funcionalidade === '' ||
      item.funcionalidade
        .toLowerCase()
        .includes(formFiltros.funcionalidade.toLowerCase());

    // Lógica de filtragem para level
    let levelFilter = true;
    if (formFiltros.level.startsWith('<')) {
      const value = parseInt(formFiltros.level.substring(1), 10);
      if (!isNaN(value)) {
        levelFilter = pontosFuncionalidade < value;
      }
    } else if (formFiltros.level.startsWith('>')) {
      const value = parseInt(formFiltros.level.substring(1), 10);
      if (!isNaN(value)) {
        levelFilter = pontosFuncionalidade > value;
      }
    } else if (/^[0-9]+$/.test(formFiltros.level)) {
      const value = parseInt(formFiltros.level, 10);
      levelFilter = pontosFuncionalidade === value;
    }

    // Lógica de filtragem para statusDesenvolvimento
    let statusFilter = true;
    if (formFiltros.statusDesenvolvimento.startsWith('<')) {
      const value = parseInt(
        formFiltros.statusDesenvolvimento.substring(1),
        10,
      );
      if (!isNaN(value)) {
        statusFilter = statusDev < value;
      }
    } else if (formFiltros.statusDesenvolvimento.startsWith('>')) {
      const value = parseInt(
        formFiltros.statusDesenvolvimento.substring(1),
        10,
      );
      if (!isNaN(value)) {
        statusFilter = statusDev > value;
      }
    } else if (/^[0-9]+$/.test(formFiltros.statusDesenvolvimento)) {
      const value = parseInt(formFiltros.statusDesenvolvimento, 10);
      statusFilter = statusDev === value;
    }

    // Retornar somente se todos os filtros forem verdadeiros
    return (
      interfaceSisAfFilter &&
      moduloSisAfFilter &&
      funcionalidadeFilter &&
      responsavelFilter &&
      levelFilter &&
      statusFilter
    );
  });

  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="250px">
              <SelectInput
                name="interfaceSisAf"
                options={interfaceSisaf}
                label="Interface"
                value={formFiltros.interfaceSisAf}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="300px">
              <SelectInput
                name="moduloSisAf"
                options={moduloDaf}
                label="Módulo"
                value={formFiltros.moduloSisAf}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="150px">
              <Input
                name="level"
                label="Level"
                value={formFiltros.level}
                id="level"
                onChange={handleChange}
                style={{ textAlign: 'right' }}
              />
            </CustomCol>
            <CustomCol width="150px">
              <Input
                name="statusDesenvolvimento"
                label="Status"
                value={formFiltros.statusDesenvolvimento}
                id="statusDesenvolvimento"
                onChange={handleChange}
                style={{ textAlign: 'right' }}
              />
            </CustomCol>
            <CustomCol>
              <Input
                name="funcionalidade"
                label="Funcionalidade"
                value={formFiltros.funcionalidade}
                id="funcionalidade"
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="200px">
              <SelectInput
                name="responsavel"
                options={responsavelTask}
                label="Responsável"
                value={formFiltros.responsavel}
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersTasks}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasTasks}
          tituloCanvas="TASK DE DESENV. DO SISAF"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              prepareDataForExport(filteredDataForExport),
              valoresExibidosOffCanvasTasks,
              fieldObjectTasks,
              'sisaf_tasks.xlsx',
              userID,
              'DAF', // Nome da interface
              entity, // Nome da entidade
            )
          }
          inserir
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default MaisOpcoesTasks;
